import { notificationTypes as actionTypes } from '@actions';
import { commonState, commonReducer, pagination } from '@dotone/react-ui-core/helpers';

const defaultState = commonState.default({ collection: true });

export const notificationList = (state = { ...defaultState, pagination }, action) =>
  commonReducer(actionTypes.LIST, state, action);

export const notificationUnreadList = (state = defaultState, action) =>
  commonReducer(actionTypes.LIST_UNREAD, state, action);

export const notificationRead = (state = { ...commonState.default(), data: {} }, action) =>
  commonReducer(actionTypes.READ, state, action);
